import type { ReactNode } from "react";

export function MediaSkeleton(): ReactNode {
  return (
    <span className="absolute top-0 left-0 z-10 size-full animate-media-skeleton bg-background-secondary bg-linear-to-br from-background-secondary via-background-tertiary to-background-secondary media-skeleton-background" />
  );
}
